import React, { useState, useEffect } from 'react';

export default function DebateFlowTool() {
  const [debates, setDebates] = useState([
    { 
      id: 1, 
      name: 'Debate 1', 
      side: 'aff',
      affFlows: { 
        'Case Flow': { args: [] }, 
        'Warming ADV': { args: [] }, 
        'Water ADV': { args: [] }, 
        'Solvency': { args: [] } 
      },
      negFlows: { 
        'Case Flow': { args: [] }, 
        'Russia DA': { args: [] }, 
        'Biodiversity DA': { args: [] }, 
        'Carbon Tax CP': { args: [] } 
      },
      customFlows: [],
      rebuttals: [{ id: 1, name: 'Rebuttal 1', content: '' }],
      crossex: [{ id: 1, name: 'Cross-Ex 1', questions: [] }]
    }
  ]);

  const [activeDebate, setActiveDebate] = useState(0);
  const [activeTab, setActiveTab] = useState('flows');
  const [activeFlow, setActiveFlow] = useState(0);
  const [activeRebuttal, setActiveRebuttal] = useState(0);
  const [activeCrossEx, setActiveCrossEx] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [textareaHeights, setTextareaHeights] = useState({});
  const [editingDebate, setEditingDebate] = useState(null);
  const [editingFlow, setEditingFlow] = useState(null);
  const [editingRebuttal, setEditingRebuttal] = useState(null);
  const [editingCrossEx, setEditingCrossEx] = useState(null);
  const [addingFlow, setAddingFlow] = useState(false);
  const [newFlowName, setNewFlowName] = useState('');
  const [timerOpen, setTimerOpen] = useState(false);
  const [speechType, setSpeechType] = useState('constructive');
  const [timeLeft, setTimeLeft] = useState(300);
  const [timerRunning, setTimerRunning] = useState(false);
  const [affPrep, setAffPrep] = useState(300);
  const [negPrep, setNegPrep] = useState(300);
  const [prepRunning, setPrepRunning] = useState(null);
  const [timerPos, setTimerPos] = useState({ x: 100, y: 100 });
  const [dragging, setDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

  const speechTimes = { constructive: 300, crossex: 120, rebuttal: 180 };
  const formatTime = (s) => `${Math.floor(s / 60)}:${(s % 60).toString().padStart(2, '0')}`;

  useEffect(() => {
    let interval;
    if (timerRunning && timeLeft > 0) interval = setInterval(() => setTimeLeft(p => p - 1), 1000);
    else if (timeLeft === 0) setTimerRunning(false);
    return () => clearInterval(interval);
  }, [timerRunning, timeLeft]);

  useEffect(() => {
    let interval;
    if (prepRunning === 'aff' && affPrep > 0) interval = setInterval(() => setAffPrep(p => p - 1), 1000);
    else if (prepRunning === 'neg' && negPrep > 0) interval = setInterval(() => setNegPrep(p => p - 1), 1000);
    else if ((prepRunning === 'aff' && affPrep === 0) || (prepRunning === 'neg' && negPrep === 0)) setPrepRunning(null);
    return () => clearInterval(interval);
  }, [prepRunning, affPrep, negPrep]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (dragging) setTimerPos({ x: e.clientX - dragOffset.x, y: e.clientY - dragOffset.y });
    };
    const handleMouseUp = () => setDragging(false);
    if (dragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [dragging, dragOffset]);

  useEffect(() => {
    if (typeof window !== 'undefined') setTimerPos({ x: window.innerWidth - 284, y: 100 });
  }, [timerOpen]);

  const currentDebate = debates[activeDebate];
  const getAllFlows = () => {
    if (!currentDebate) return [];
    const obj = currentDebate.side === 'aff' ? currentDebate.affFlows : currentDebate.negFlows;
    return [...Object.keys(obj).map(n => ({ name: n, args: obj[n]?.args || [], isPreset: true })), ...(currentDebate.customFlows || [])];
  };
  const allFlows = getAllFlows();
  const currentFlow = allFlows[activeFlow];
  const accentColor = currentDebate?.side === 'aff' ? '#007aff' : '#ff3b30';

  const updateFlowArgs = (newArgs) => {
    const updated = [...debates];
    const key = currentDebate.side === 'aff' ? 'affFlows' : 'negFlows';
    if (currentFlow?.isPreset) updated[activeDebate][key][currentFlow.name].args = newArgs;
    else {
      const idx = activeFlow - Object.keys(currentDebate.side === 'aff' ? currentDebate.affFlows : currentDebate.negFlows).length;
      updated[activeDebate].customFlows[idx].args = newArgs;
    }
    setDebates(updated);
  };

  const bg = '#1a1a1a', panel = '#2a2a2a', surface = '#3a3a3a', text = '#e8e8e8', muted = '#8e8e93', border = '#3a3a3a';

  return (
    <div style={{ minHeight: '100vh', background: bg, display: 'flex', fontFamily: '-apple-system, sans-serif' }}>

      {/* Sidebar */}
      <div style={{ width: sidebarOpen ? '280px' : '0', background: panel, borderRight: sidebarOpen ? `1px solid ${border}` : 'none',
        padding: sidebarOpen ? '32px 20px' : '0', overflow: 'hidden', transition: 'all 0.3s', flexShrink: 0 }}>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 style={{ fontSize: '18px', color: text, margin: 0 }}>Debates</h2>
          <button onClick={() => {
            const d = { id: Date.now(), name: `Debate ${debates.length + 1}`, side: 'aff',
              affFlows: { 'Case Flow': { args: [] }, 'Warming ADV': { args: [] }, 'Water ADV': { args: [] }, 'Solvency': { args: [] } },
              negFlows: { 'Case Flow': { args: [] }, 'Russia DA': { args: [] }, 'Biodiversity DA': { args: [] }, 'Carbon Tax CP': { args: [] } },
              customFlows: [], rebuttals: [{ id: Date.now(), name: 'Rebuttal 1', content: '' }], crossex: [{ id: Date.now(), name: 'Cross-Ex 1', questions: [] }] };
            setDebates([...debates, d]); setActiveDebate(debates.length); setActiveFlow(0); setActiveRebuttal(0); setActiveCrossEx(0);
          }} style={{ background: 'none', color: '#007aff', border: 'none', cursor: 'pointer', fontSize: '24px' }}>+</button>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <span style={{ fontSize: '14px', color: text }}>Side:</span>
          <button onClick={() => {
            const u = [...debates]; u[activeDebate].side = u[activeDebate].side === 'aff' ? 'neg' : 'aff';
            setDebates(u); setActiveFlow(0);
          }} style={{ padding: '6px 14px', background: accentColor, color: '#fff', border: 'none', borderRadius: '980px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>
            {currentDebate.side === 'aff' ? 'AFF' : 'NEG'}
          </button>
        </div>

        {debates.map((d, i) => (
          <div key={d.id} style={{ marginBottom: '8px', display: 'flex', gap: '8px' }}>
            {editingDebate === i
              ? <input autoFocus value={d.name} onChange={(e) => { const u = [...debates]; u[i].name = e.target.value; setDebates(u); }}
                  onBlur={() => setEditingDebate(null)} onKeyDown={(e) => e.key === 'Enter' && setEditingDebate(null)}
                  style={{ flex: 1, padding: '12px', background: bg, color: text, border: `2px solid ${accentColor}`, borderRadius: '12px', fontSize: '14px', outline: 'none' }} />
              : <button onClick={() => { setActiveDebate(i); setActiveFlow(0); }} onDoubleClick={() => setEditingDebate(i)}
                  style={{ flex: 1, padding: '12px', background: activeDebate === i ? accentColor : 'transparent', color: activeDebate === i ? '#fff' : text,
                    border: 'none', borderRadius: '12px', cursor: 'pointer', textAlign: 'left' }}>{d.name}</button>
            }
            {debates.length > 1 && <button onClick={() => {
              const u = debates.filter((_, idx) => idx !== i); setDebates(u);
              if (activeDebate >= u.length) setActiveDebate(Math.max(0, u.length - 1));
            }} style={{ background: surface, color: '#ff3b30', border: 'none', width: '36px', height: '36px', borderRadius: '12px', cursor: 'pointer', fontSize: '18px' }}>×</button>}
          </div>
        ))}

        <div style={{ borderTop: `1px solid ${border}`, marginTop: '24px', paddingTop: '24px' }}>
          <div style={{ display: 'flex', gap: '6px', marginBottom: '16px' }}>
            {['flows', 'crossex', 'rebuttals'].map(t => (
              <button key={t} onClick={() => setActiveTab(t)}
                style={{ flex: 1, padding: '10px', background: activeTab === t ? accentColor : 'transparent',
                  color: activeTab === t ? '#fff' : text, border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '12px' }}>
                {t === 'crossex' ? 'CX' : t.charAt(0).toUpperCase() + t.slice(1)}
              </button>
            ))}
          </div>

          {/* Flows list */}
          {activeTab === 'flows' && <>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
              <h3 style={{ fontSize: '16px', color: text, margin: 0 }}>Flows</h3>
              <button onClick={() => setAddingFlow(true)} style={{ background: 'none', color: '#007aff', border: 'none', cursor: 'pointer', fontSize: '20px' }}>+</button>
            </div>
            {addingFlow && <input autoFocus placeholder="Flow name..." value={newFlowName} onChange={(e) => setNewFlowName(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter' && newFlowName.trim()) {
                const u = [...debates]; u[activeDebate].customFlows.push({ name: newFlowName.trim(), args: [], isPreset: false });
                setDebates(u); setAddingFlow(false); setNewFlowName('');
              }}}
              onBlur={() => { setAddingFlow(false); setNewFlowName(''); }}
              style={{ width: '100%', padding: '10px', marginBottom: '12px', background: bg, color: text, border: `2px solid ${accentColor}`, borderRadius: '10px', outline: 'none' }} />}
            {allFlows.map((f, i) => (
              <div key={i} style={{ display: 'flex', gap: '6px', marginBottom: '6px' }}>
                {editingFlow === i
                  ? <input autoFocus value={f.name} onChange={(e) => {
                      const u = [...debates];
                      if (f.isPreset) { const k = currentDebate.side === 'aff' ? 'affFlows' : 'negFlows'; u[activeDebate][k][e.target.value] = u[activeDebate][k][f.name]; delete u[activeDebate][k][f.name]; }
                      else { const idx = i - Object.keys(currentDebate.side === 'aff' ? currentDebate.affFlows : currentDebate.negFlows).length; u[activeDebate].customFlows[idx].name = e.target.value; }
                      setDebates(u);
                    }} onBlur={() => setEditingFlow(null)} onKeyDown={(e) => e.key === 'Enter' && setEditingFlow(null)}
                    style={{ flex: 1, padding: '10px', background: bg, color: text, border: `2px solid ${accentColor}`, borderRadius: '10px', outline: 'none' }} />
                  : <button onClick={() => setActiveFlow(i)} onDoubleClick={() => setEditingFlow(i)}
                      style={{ flex: 1, padding: '10px', background: activeFlow === i ? accentColor : 'transparent', color: activeFlow === i ? '#fff' : text,
                        border: 'none', borderRadius: '10px', cursor: 'pointer', textAlign: 'left', fontSize: '13px' }}>{f.name}</button>
                }
                {!f.isPreset && <button onClick={() => {
                  const u = [...debates]; const idx = i - Object.keys(currentDebate.side === 'aff' ? currentDebate.affFlows : currentDebate.negFlows).length;
                  u[activeDebate].customFlows.splice(idx, 1); setDebates(u);
                }} style={{ background: surface, color: '#ff3b30', border: 'none', width: '28px', height: '28px', borderRadius: '8px', cursor: 'pointer' }}>×</button>}
              </div>
            ))}
          </>}

          {/* CX list */}
          {activeTab === 'crossex' && <>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
              <h3 style={{ fontSize: '16px', color: text, margin: 0 }}>Cross-Ex</h3>
              <button onClick={() => {
                const u = [...debates]; u[activeDebate].crossex.push({ id: Date.now(), name: `Cross-Ex ${u[activeDebate].crossex.length + 1}`, questions: [] });
                setDebates(u); setActiveCrossEx(u[activeDebate].crossex.length - 1);
              }} style={{ background: 'none', color: '#007aff', border: 'none', cursor: 'pointer', fontSize: '20px' }}>+</button>
            </div>
            {currentDebate.crossex?.map((cx, i) => (
              <div key={cx.id} style={{ display: 'flex', gap: '6px', marginBottom: '6px' }}>
                {editingCrossEx === i
                  ? <input autoFocus value={cx.name} onChange={(e) => { const u = [...debates]; u[activeDebate].crossex[i].name = e.target.value; setDebates(u); }}
                      onBlur={() => setEditingCrossEx(null)} onKeyDown={(e) => e.key === 'Enter' && setEditingCrossEx(null)}
                      style={{ flex: 1, padding: '10px', background: bg, color: text, border: `2px solid ${accentColor}`, borderRadius: '10px', outline: 'none' }} />
                  : <button onClick={() => { setActiveCrossEx(i); setActiveTab('crossex'); }} onDoubleClick={() => setEditingCrossEx(i)}
                      style={{ flex: 1, padding: '10px', background: activeCrossEx === i && activeTab === 'crossex' ? accentColor : 'transparent',
                        color: activeCrossEx === i && activeTab === 'crossex' ? '#fff' : text, border: 'none', borderRadius: '10px', cursor: 'pointer', textAlign: 'left', fontSize: '13px' }}>{cx.name}</button>
                }
                {currentDebate.crossex.length > 1 && <button onClick={() => {
                  const u = [...debates]; u[activeDebate].crossex.splice(i, 1); setDebates(u);
                  if (activeCrossEx >= u[activeDebate].crossex.length) setActiveCrossEx(Math.max(0, u[activeDebate].crossex.length - 1));
                }} style={{ background: surface, color: '#ff3b30', border: 'none', width: '28px', height: '28px', borderRadius: '8px', cursor: 'pointer' }}>×</button>}
              </div>
            ))}
          </>}

          {/* Rebuttals list */}
          {activeTab === 'rebuttals' && <>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
              <h3 style={{ fontSize: '16px', color: text, margin: 0 }}>Rebuttals</h3>
              <button onClick={() => {
                const u = [...debates]; u[activeDebate].rebuttals.push({ id: Date.now(), name: `Rebuttal ${u[activeDebate].rebuttals.length + 1}`, content: '' });
                setDebates(u); setActiveRebuttal(u[activeDebate].rebuttals.length - 1);
              }} style={{ background: 'none', color: '#007aff', border: 'none', cursor: 'pointer', fontSize: '20px' }}>+</button>
            </div>
            {currentDebate.rebuttals?.map((r, i) => (
              <div key={r.id} style={{ display: 'flex', gap: '6px', marginBottom: '6px' }}>
                {editingRebuttal === i
                  ? <input autoFocus value={r.name} onChange={(e) => { const u = [...debates]; u[activeDebate].rebuttals[i].name = e.target.value; setDebates(u); }}
                      onBlur={() => setEditingRebuttal(null)} onKeyDown={(e) => e.key === 'Enter' && setEditingRebuttal(null)}
                      style={{ flex: 1, padding: '10px', background: bg, color: text, border: `2px solid ${accentColor}`, borderRadius: '10px', outline: 'none' }} />
                  : <button onClick={() => setActiveRebuttal(i)} onDoubleClick={() => setEditingRebuttal(i)}
                      style={{ flex: 1, padding: '10px', background: activeRebuttal === i ? accentColor : 'transparent', color: activeRebuttal === i ? '#fff' : text,
                        border: 'none', borderRadius: '10px', cursor: 'pointer', textAlign: 'left', fontSize: '13px' }}>{r.name}</button>
                }
                {currentDebate.rebuttals.length > 1 && <button onClick={() => {
                  const u = [...debates]; u[activeDebate].rebuttals.splice(i, 1); setDebates(u);
                  if (activeRebuttal >= u[activeDebate].rebuttals.length) setActiveRebuttal(Math.max(0, u[activeDebate].rebuttals.length - 1));
                }} style={{ background: surface, color: '#ff3b30', border: 'none', width: '28px', height: '28px', borderRadius: '8px', cursor: 'pointer' }}>×</button>}
              </div>
            ))}
          </>}
        </div>
      </div>

      {/* Main */}
      <div style={{ flex: 1, padding: '32px', overflowY: 'auto' }}>
        <button onClick={() => setSidebarOpen(!sidebarOpen)}
          style={{ position: 'fixed', top: '32px', left: sidebarOpen ? '268px' : '20px', background: panel, border: `1px solid ${border}`,
            width: '36px', height: '36px', borderRadius: '50%', cursor: 'pointer', fontSize: '18px', color: text, zIndex: 10 }}>
          {sidebarOpen ? '‹' : '›'}
        </button>

        <div style={{ maxWidth: '1200px', margin: '0 auto', marginLeft: sidebarOpen ? '0' : '40px' }}>
          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '32px' }}>
            <div>
              <h1 style={{ fontSize: '36px', color: text, margin: 0 }}>
                {activeTab === 'flows' ? currentFlow?.name : activeTab === 'crossex' ? currentDebate.crossex?.[activeCrossEx]?.name : currentDebate.rebuttals?.[activeRebuttal]?.name}
              </h1>
              <p style={{ color: muted, margin: 0 }}>{currentDebate.name} · {currentDebate.side.toUpperCase()}</p>
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
              {['flows', 'crossex', 'rebuttals'].map(t => (
                <button key={t} onClick={() => setActiveTab(t)}
                  style={{ padding: '10px 20px', background: activeTab === t ? accentColor : panel, color: activeTab === t ? '#fff' : text,
                    border: `1px solid ${border}`, borderRadius: '980px', cursor: 'pointer', fontWeight: '600' }}>
                  {t === 'crossex' ? 'Cross-Ex' : t.charAt(0).toUpperCase() + t.slice(1)}
                </button>
              ))}
              <button onClick={() => setTimerOpen(!timerOpen)}
                style={{ padding: '10px 20px', background: timerOpen ? accentColor : panel, color: timerOpen ? '#fff' : text, border: `1px solid ${border}`, borderRadius: '980px', cursor: 'pointer' }}>
                ⏱ Timer
              </button>
            </div>
          </div>

          {/* Timer widget */}
          {timerOpen && (
            <div style={{ position: 'fixed', left: `${timerPos.x}px`, top: `${timerPos.y}px`, background: panel,
              border: `1px solid ${border}`, borderRadius: '16px', padding: '20px', boxShadow: '0 8px 32px rgba(0,0,0,0.4)', zIndex: 100, width: '240px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', cursor: 'grab' }}
                onMouseDown={(e) => { setDragging(true); setDragOffset({ x: e.clientX - timerPos.x, y: e.clientY - timerPos.y }); }}>
                <h3 style={{ color: text, margin: 0, fontSize: '16px' }}>Timer</h3>
                <button onClick={() => setTimerOpen(false)} style={{ background: 'none', border: 'none', color: muted, cursor: 'pointer', fontSize: '20px', padding: 0 }}>×</button>
              </div>

              {/* Speech type tabs */}
              <div style={{ display: 'flex', gap: '6px', marginBottom: '12px' }}>
                {['constructive', 'crossex', 'rebuttal'].map(t => (
                  <button key={t} onClick={() => { setSpeechType(t); setTimeLeft(speechTimes[t]); setTimerRunning(false); }}
                    style={{ flex: 1, padding: '6px 4px', background: speechType === t ? '#007aff' : surface, color: speechType === t ? '#fff' : text,
                      border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '11px' }}>
                    {t === 'constructive' ? 'Con.' : t === 'crossex' ? 'CX' : 'Reb.'}
                  </button>
                ))}
              </div>

              {/* Countdown */}
              <div style={{ fontSize: '42px', fontWeight: '700', textAlign: 'center', color: timeLeft <= 30 ? '#ff3b30' : text, marginBottom: '12px', letterSpacing: '-1px' }}>
                {formatTime(timeLeft)}
              </div>
              <div style={{ display: 'flex', gap: '6px', marginBottom: '20px' }}>
                <button onClick={() => setTimerRunning(!timerRunning)}
                  style={{ flex: 1, padding: '10px', background: timerRunning ? '#ff9500' : '#34c759', color: '#fff', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>
                  {timerRunning ? 'Pause' : 'Start'}
                </button>
                <button onClick={() => { setTimerRunning(false); setTimeLeft(speechTimes[speechType]); }}
                  style={{ flex: 1, padding: '10px', background: surface, color: text, border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>
                  Reset
                </button>
              </div>

              {/* Prep time */}
              <div style={{ borderTop: `1px solid ${border}`, paddingTop: '16px' }}>
                <p style={{ color: muted, fontSize: '11px', margin: '0 0 12px 0', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Prep Time</p>
                {[['aff', affPrep, setAffPrep, '#007aff'], ['neg', negPrep, setNegPrep, '#ff3b30']].map(([side, time, setTime, color]) => (
                  <div key={side} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                    <span style={{ fontSize: '11px', fontWeight: '700', color, width: '28px', textTransform: 'uppercase' }}>{side}</span>
                    <span style={{ fontSize: '22px', fontWeight: '700', color: time <= 30 ? '#ff3b30' : text, flex: 1, textAlign: 'center' }}>
                      {formatTime(time)}
                    </span>
                    <button onClick={() => setPrepRunning(prepRunning === side ? null : side)}
                      style={{ padding: '5px 10px', background: prepRunning === side ? '#ff9500' : '#34c759', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>
                      {prepRunning === side ? 'Stop' : 'Use'}
                    </button>
                    <button onClick={() => { if (prepRunning === side) setPrepRunning(null); setTime(300); }}
                      style={{ padding: '5px 8px', background: surface, color: text, border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' }}>↺</button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Flows */}
          {activeTab === 'flows' && currentFlow && (
            <div style={{ background: panel, padding: '24px', borderRadius: '20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <h3 style={{ color: text, margin: 0 }}>Arguments</h3>
                <button onClick={() => updateFlowArgs([...(currentFlow?.args || []), { id: Date.now(), s1: '', s2: '', s3: '', s4: '' }])}
                  style={{ padding: '8px 18px', background: accentColor, color: '#fff', border: 'none', borderRadius: '980px', cursor: 'pointer' }}>
                  + Add Row
                </button>
              </div>
              <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '10px' }}>
                <thead>
                  <tr>{['1AC/1NC', '2AC/2NC', '1AR/1NR', '2AR/2NR', ''].map((h, i) => (
                    <th key={i} style={{ color: muted, fontSize: '12px', textAlign: 'left', width: i === 4 ? '40px' : 'auto' }}>{h}</th>
                  ))}</tr>
                </thead>
                <tbody>
                  {currentFlow?.args?.map((arg, i) => (
                    <tr key={arg.id}>
                      {['s1', 's2', 's3', 's4'].map((s, j) => (
                        <td key={j} style={{ padding: 0 }}>
                          <textarea value={arg[s]} onChange={(e) => {
                            const na = [...currentFlow.args]; na[i][s] = e.target.value; updateFlowArgs(na);
                            const ta = e.target; ta.style.height = 'auto';
                            setTextareaHeights(prev => ({ ...prev, [`row-${i}`]: Math.max(90, ta.scrollHeight) }));
                          }}
                            style={{ width: '100%', height: textareaHeights[`row-${i}`] ? `${textareaHeights[`row-${i}`]}px` : '90px', minHeight: '90px',
                              padding: '12px', background: bg, color: text, border: 'none', borderRadius: '10px',
                              fontFamily: 'inherit', fontSize: '13px', outline: 'none', resize: 'none', overflow: 'hidden' }}
                            placeholder={j === 0 ? 'Argument...' : ''} />
                        </td>
                      ))}
                      <td style={{ padding: 0, textAlign: 'center' }}>
                        <button onClick={() => updateFlowArgs(currentFlow.args.filter((_, idx) => idx !== i))}
                          style={{ background: '#ff3b30', color: '#fff', border: 'none', width: '28px', height: '28px', borderRadius: '50%', cursor: 'pointer' }}>×</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Cross-Ex */}
          {activeTab === 'crossex' && currentDebate.crossex?.[activeCrossEx] && (
            <div style={{ background: panel, padding: '24px', borderRadius: '20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <h3 style={{ color: text, margin: 0 }}>{currentDebate.crossex[activeCrossEx].name}</h3>
                <button onClick={() => {
                  const u = [...debates];
                  if (!u[activeDebate].crossex[activeCrossEx].questions) u[activeDebate].crossex[activeCrossEx].questions = [];
                  u[activeDebate].crossex[activeCrossEx].questions.push({ id: Date.now(), text: '' });
                  setDebates(u);
                }} style={{ padding: '8px 18px', background: accentColor, color: '#fff', border: 'none', borderRadius: '980px', cursor: 'pointer' }}>
                  + Add Question
                </button>
              </div>
              {currentDebate.crossex[activeCrossEx].questions?.map((q, i) => (
                <div key={q.id} style={{ marginBottom: '12px', display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <div style={{ background: accentColor, color: '#fff', minWidth: '32px', height: '32px', borderRadius: '50%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '600', fontSize: '14px', flexShrink: 0 }}>{i + 1}</div>
                  <textarea value={q.text} onChange={(e) => { const u = [...debates]; u[activeDebate].crossex[activeCrossEx].questions[i].text = e.target.value; setDebates(u); }}
                    placeholder="Enter your question..."
                    style={{ flex: 1, minHeight: '60px', padding: '12px', background: bg, color: text, border: 'none', borderRadius: '10px', fontFamily: 'inherit', fontSize: '14px', outline: 'none', resize: 'vertical' }} />
                  <button onClick={() => { const u = [...debates]; u[activeDebate].crossex[activeCrossEx].questions.splice(i, 1); setDebates(u); }}
                    style={{ background: '#ff3b30', color: '#fff', border: 'none', width: '32px', height: '32px', borderRadius: '50%', cursor: 'pointer', flexShrink: 0 }}>×</button>
                </div>
              ))}
              {!currentDebate.crossex[activeCrossEx].questions?.length && (
                <p style={{ color: muted, textAlign: 'center', padding: '40px' }}>No questions yet. Click "+ Add Question" to get started.</p>
              )}
            </div>
          )}

          {/* Rebuttals */}
          {activeTab === 'rebuttals' && currentDebate.rebuttals?.[activeRebuttal] && (
            <div style={{ background: panel, padding: '24px', borderRadius: '20px' }}>
              <textarea value={currentDebate.rebuttals[activeRebuttal].content}
                onChange={(e) => { const u = [...debates]; u[activeDebate].rebuttals[activeRebuttal].content = e.target.value; setDebates(u); }}
                placeholder="Type your rebuttal notes here..."
                style={{ width: '100%', minHeight: '500px', padding: '16px', background: bg, color: text, border: 'none',
                  borderRadius: '12px', fontFamily: 'inherit', fontSize: '15px', lineHeight: '1.6', outline: 'none', resize: 'vertical' }} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}